import React, { useState } from 'react'
import Layout from '../src/components/Layout'



import ThankYou from '../src/components/ThankYou'
import SignOut from '../src/components/SignOut'
import SubmitPayment from '../src/components/SubmitPayment'
import Registration from '../src/components/Registration'
import Profile   from '../src/components/Profile'
import Accolades from '../src/components/Accolades'
import Login from '../src/components/Login'

import ThankYouReservation from '../src/components/ThankYou/reservation_thankyou'

//pages
import Location from '../src/pages/Location'
import Main from '../src/pages/Main'
import Events from '../src/pages/Events'
import Welcome from '../src/pages/Welcome'
import SubmitEvents from '../src/pages/SubmitEvents'
import Services from '../src/pages/Services'
import About from '../src/pages/About'
import Careers from '../src/pages/Careers'
import Employees from '../src/pages/Employees'
import PerformanceMeasures from '../src/pages/PerformanceMeasures'
// import NewsDetails from '../src/pages/NewsDetails'
import EventDetails from '../src/pages/EventDetails'
import Staff from '../src/pages/Staff'
import Tina_Archer from '../src/pages/Staff/Tina_Archer'
// import News from '../src/pages/News'
// import SubmitNews from '../src/pages/SubmitNews'

import { UserContext } from './UserContext'
import { OrderContext } from './OrderContext'
import { MenuContext } from './MenuContext'
import { StoreContext } from './StoreContext'

import { Router, Route, Switch} from "react-router-dom"
import history from "../src/components/History"
import UserProtectedRoute from '../src/components/UserProtectedRoutes'
import AdminProtectedRoute from '../src/components/AdminProtectedRoutes'
import NoMatch from '../src/components/NoMatch'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUser as farUser } from '@fortawesome/free-regular-svg-icons'
import { faUserCog } from '@fortawesome/free-solid-svg-icons'



library.add(farUser, faUserCog)

export default function App() {
  //User Information
  const [isLoggedIn, setLoggedIn] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [userInfo, setUserInfo] = useState({});

  //Menu Order
  const [submittedOrder, setSubmittedOrder] = useState({})

  const [menuInfo, setMenuInfo] = useState([])
  const [storeInfo, setStoreInfo] = useState([])
  const [orderText, setOrderText] = useState(``)

  return (
    <Router history={history}>
    <UserContext.Provider value={{isLoggedIn, setLoggedIn, isAdmin, setIsAdmin, userInfo, setUserInfo}}>
    <MenuContext.Provider value={{menuInfo, setMenuInfo}}>
    <StoreContext.Provider value={{storeInfo, setStoreInfo}}>
    <OrderContext.Provider value={{orderText, setOrderText, submittedOrder, setSubmittedOrder}}>  
    
    <Layout>
    <Switch>
      
          <Route exact path="/" component={Main} />
          <Route exact path="/About" component={About} />
  
          <Route exact path="/Location" component={Location} />
          <Route exact path="/Registration" component={Registration}/>
          <Route exact path="/SignOut" component={SignOut} />
          <Route exact path="/Accolades" component={Accolades} />
          <Route exact path="/SubmitPayment" component={SubmitPayment} />
          <Route exact path="/ThankYou" component={ThankYou} />
          <Route exact path="/Staff" component={Staff}/>
          <Route exact path="/Staff/Tina_Archer" component={Tina_Archer} />
          <Route exact path="/Employees" component={Employees}/>
          <Route exact path="/PerformanceMeasures" component={PerformanceMeasures}/>
          <Route exact path="/Login" component={Login} />
          <Route exact path="/ThankYouReservation" component={ThankYouReservation} />
          <Route exact path="/Events" component={Events}/>
          <Route exact path="/EventDetails/:id" component={EventDetails} />
          {/* <Route exact path="/News" component={News} /> */}
          <Route exact path="/Services" component={Services}/>
      
          <Route exact path="/Careers" component={Careers}/>
          {/* <Route exact path="/NewsDetails/:id" component={NewsDetails} /> */}
          <UserProtectedRoute exact path="/Welcome" component={Welcome} />  
          <AdminProtectedRoute exact path="/SubmitEvents" component={SubmitEvents} />
          <UserProtectedRoute exact path="/Profile" component={Profile} />
          <Route component={NoMatch} />
          
    </Switch>
    </Layout>
 
    </OrderContext.Provider>
    </StoreContext.Provider>    
    </MenuContext.Provider>
    </UserContext.Provider>
    </Router>
  )
}
